var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conference"},[_c('div',{staticClass:"conference-body"},[_c('vue-jitsi-meet',{ref:"jitsiRef",attrs:{"domain":"meet.jit.si","options":_vm.jitsiOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }